import { VARIANT_MORE_BUTTON_CLICK } from 'common/components/product-variants/ducks/actions';
import { put, takeEvery } from 'redux-saga/effects';
import { createAction } from 'typesafe-actions';

/**
 * Cобытие должно срабатывать при клике на раскрытие вариантов.
 *
 * @see https://docs.google.com/document/d/1qQ6_QglkwskDA8x5RIW20OnGONBvb-CXFHSidE0wZiY/edit
 */
export const gaClickMoreButton = createAction('GA:clickButton')<{
  elementType: 'button';
  elementBlock: 'productDetail / variants'; // блок, в котором расположен элемент

  elementName: string; // текст кнопки
  elementText: string; // нахвание блока
}>();

export function* putGaClickMoreButton(elementName: string, elementText: string) {
  yield put(
    gaClickMoreButton({
      elementType: 'button',
      elementBlock: 'productDetail / variants',
      elementName: `+${elementName}`,
      elementText: elementText,
    }),
  );
}

export function* runGaClickMoreButtonDetector() {
  yield takeEvery(
    VARIANT_MORE_BUTTON_CLICK,
    function* handle({ payload }: ReturnType<typeof VARIANT_MORE_BUTTON_CLICK>) {
      const { extraVariantsToShow, axisTitle } = payload;
      yield putGaClickMoreButton(String(extraVariantsToShow), axisTitle);
    },
  );
}
